<script>
  import { browser } from '$app/environment';
  import InviteOg from '@og/Invite.svelte';

  import '@vendor/default-landing-page.css';

  let LandingPage;

  export let data;

  let { code, user, mutualSuggestedFollow, suggestedFollow } = data;

  if (browser) {
    (async () => {
      LandingPage = (await import('@pages/demo/Tiktok.svelte')).default;
    })();
  }
</script>

<InviteOg user={user} mutualSuggestedFollow={mutualSuggestedFollow} suggestedFollow={suggestedFollow} code={code} />

<svelte:head>
  <meta name="robots" content="noindex" />
</svelte:head>
{#if browser}
  <svelte:component this={LandingPage} inviteCode={code} />
{/if}
